import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getRfiCmsData } from '@Redux/selectors';
import { CenterContainer } from './styles';
import { EKYC_RFI_SUCCESS_PAGE } from './utils';
import { CommonButton } from '@Components';
import { APPROVE_NEW_ICON } from '@Images';
import { DASHBOARD_URL, TRANSFER_MONEY_URL } from '@Utils/constants';

const EkycRFISuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const successPageCMSData = useSelector(getRfiCmsData)?.ekycRFI?.successPage;
  const { heading, description, goToHomeCTA, sendMoneyCTA } =
    successPageCMSData ?? EKYC_RFI_SUCCESS_PAGE;

  const handleGoToHome = () => {
    navigate(DASHBOARD_URL);
  };
  const handleGoToSendMoney = () => {
    navigate(TRANSFER_MONEY_URL);
  };

  return (
    <CenterContainer>
      <div className="innerContainer">
        <div className="img">
          <img src={APPROVE_NEW_ICON} alt="Check mark Icon" />
        </div>
        <div className="heading">{heading}</div>
        <div className="description">{description}</div>
        <div className="sendMoneyBtnWrapper">
          <CommonButton text={sendMoneyCTA} onClick={handleGoToSendMoney} />
        </div>
        <div className="btnWrapper">
          <CommonButton text={goToHomeCTA} onClick={handleGoToHome} type="link" />
        </div>
      </div>
    </CenterContainer>
  );
};

export default EkycRFISuccessPage;
